const items = [
  { rank: 1, title: '肖申克的救赎', score: '9.7', genre: '剧情 / 犯罪', tag: '经典', trend: 'up' },
  { rank: 2, title: '盗梦空间', score: '9.3', genre: '科幻 / 悬疑', tag: '热门', trend: 'up' },
  { rank: 3, title: '星际穿越', score: '9.4', genre: '科幻 / 冒险', tag: '推荐', trend: 'same' },
  { rank: 4, title: '千与千寻', score: '9.4', genre: '动画 / 奇幻', tag: '经典', trend: 'up' },
  { rank: 5, title: '泰坦尼克号', score: '9.4', genre: '爱情 / 灾难', tag: '热门', trend: 'down' },
  { rank: 6, title: '楚门的世界', score: '9.3', genre: '剧情 / 科幻', tag: '推荐', trend: 'up' },
  { rank: 7, title: '这个杀手不太冷', score: '9.4', genre: '动作 / 剧情', tag: '经典', trend: 'same' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-end justify-between mb-8 flex-wrap gap-3">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
              本周热播榜单
            </h2>
            <p className="mt-1.5 text-sm text-foreground-600">
              影迷们正在观看的高分好片
            </p>
          </div>
          <div className="flex items-center gap-2">
            <span className="px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap cursor-pointer">本周</span>
            <span className="px-3 py-1.5 rounded-full bg-background-100 text-foreground-600 text-xs font-medium whitespace-nowrap cursor-pointer">本月</span>
            <span className="px-3 py-1.5 rounded-full bg-background-100 text-foreground-600 text-xs font-medium whitespace-nowrap cursor-pointer">全部</span>
          </div>
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden">
          <div className="hidden sm:grid grid-cols-12 gap-4 px-5 py-3 border-b border-background-200/70 text-xs font-medium text-foreground-500">
            <div className="col-span-1">排名</div>
            <div className="col-span-5">电影名称</div>
            <div className="col-span-2">类型</div>
            <div className="col-span-2">评分</div>
            <div className="col-span-2">趋势</div>
          </div>
          {items.map((item) => (
            <div
              key={item.rank}
              className="grid grid-cols-1 sm:grid-cols-12 gap-2 sm:gap-4 px-5 py-4 border-b border-background-200/40 last:border-b-0 items-center hover:bg-background-50 transition-colors"
            >
              <div className="sm:col-span-1 flex items-center gap-3 sm:gap-0">
                <span className={`w-7 h-7 rounded-md flex items-center justify-center text-xs font-bold ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}>
                  {item.rank}
                </span>
                <span className="sm:hidden text-sm font-semibold text-foreground-900">{item.title}</span>
              </div>
              <div className="hidden sm:block sm:col-span-5">
                <div className="flex items-center gap-3">
                  <span className="text-sm font-semibold text-foreground-900">{item.title}</span>
                  <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-accent-100 text-accent-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="sm:col-span-2 text-xs text-foreground-600 sm:block hidden">{item.genre}</div>
              <div className="sm:col-span-2 flex items-center gap-1.5">
                <i className="ri-star-fill text-amber-400 text-sm"></i>
                <span className="text-sm font-semibold text-foreground-900">{item.score}</span>
              </div>
              <div className="sm:col-span-2">
                <span className={`inline-flex items-center gap-1 text-xs ${
                  item.trend === 'up' ? 'text-green-600' : item.trend === 'down' ? 'text-red-500' : 'text-foreground-500'
                }`}>
                  <i className={`text-xs ${item.trend === 'up' ? 'ri-arrow-up-line' : item.trend === 'down' ? 'ri-arrow-down-line' : 'ri-subtract-line'}`}></i>
                  {item.trend === 'up' ? '上升' : item.trend === 'down' ? '下降' : '持平'}
                </span>
              </div>
              <div className="sm:hidden flex items-center gap-4 text-xs text-foreground-600">
                <span>{item.genre}</span>
                <span className="flex items-center gap-1"><i className="ri-star-fill text-amber-400"></i>{item.score}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}